
import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getCalendarList } from "store/services/accountSettingService";

const CalendarPicker = ({
    onOffPop,
    setOnOffPop,
    heading,
    selectedCalendar,
    setSelectedCalendar,
    handleSubmit,
    handleChange,
    sending,
}) => {
    const dispatch = useDispatch()
    const [tempSelectedCalendar, setTempSelectedCalendar] = useState(selectedCalendar);
    const [calendarListData, setCalendarListData] = useState(null);
    const [isLoadingCalendars, setIsLoadingCalendars] = useState(false);

    const handleOnOff = () => {
        setOnOffPop(!onOffPop);
    };

    const handleGetCalendarList = async () => {
        try {
            setIsLoadingCalendars(true);
            const resp = await dispatch(getCalendarList());
            if (resp.success) {
                const filtered = resp?.body?.filter((item) => item?.hasWriteAccess)
                setCalendarListData(filtered)
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoadingCalendars(false);
        }
    };
    useEffect(() => {
        if (onOffPop) {
            if (!calendarListData) {
                handleGetCalendarList();
            }
            setTempSelectedCalendar(selectedCalendar);
        }
    }, [onOffPop, selectedCalendar, calendarListData]);
 

    return (
        <>
            <Form>
                <Modal
                    show={onOffPop}
                    onHide={handleOnOff}
                    backdrop="static"
                    keyboard={false}
                    centered
                    className="FormPop"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{heading}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {isLoadingCalendars ? (
                            <p className="mb-0">Loading...</p>
                        ) : (
                            <ul className="list-unstyled ps-0 mb-0">
                                {
                                    calendarListData?.map((item) => {
                                        return (
                                            <li className="py-1">
                                                <div className="py-2 d-flex align-items-start">
                                                    <div className="cstmInputCheckWrp radio position-relative me-2">
                                                        <input
                                                            type="radio"
                                                            name="calendar"
                                                            className="position-absolute w-100 h-100"
                                                            value={item?.id}
                                                            checked={tempSelectedCalendar?.id === item?.id}
                                                            onChange={() => setTempSelectedCalendar(item)}
                                                        />
                                                        <div className="cstmInputCheck h-100 w-100 rounded-circle d-flex align-items-center justify-content-center">
                                                            <span className="icn d-none rounded-circle">
                                                                {/* <OTick /> */}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-2 flex-wrap">
                                                        <h6 className="fw-sbold m-0">{item?.summary}</h6>
                                                        <span
                                                            className={`badge ${item?.primary ? "bg-primary" : "bg-secondary"}`}
                                                            style={{ fontSize: "0.7rem", fontWeight: 500 }}
                                                        >
                                                            {item?.primary ? "Primary" : "Secondary"}
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        )}
                    </Modal.Body>
                    <Modal.Footer className="FormbtnWrpper">
                        <Button
                            className="d-flex align-items-center justify-content-center commonBtn btnSm"
                            onClick={handleOnOff}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            onClick={() => { 
                                handleSubmit(tempSelectedCalendar);
                                setOnOffPop(false);
                            }}
                            className="d-flex align-items-center justify-content-center commonBtn btnSm"
                        >
                            {sending ? "wait..." : "Save"}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Form>
        </>
    );
};

export default CalendarPicker;
